// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "mainSite." + "main" + "." + "edeb57247f64a371e44d" + ".css";
};